import { render, staticRenderFns } from "./ServiceDescription.vue?vue&type=template&id=544b882f&scoped=true&lang=pug&"
import script from "./ServiceDescription.vue?vue&type=script&lang=js&"
export * from "./ServiceDescription.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDescription.vue?vue&type=style&index=0&id=544b882f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544b882f",
  null
  
)

export default component.exports